import { Tag } from "antd";
import type { TagProps } from "antd";
import { Role, UserPermission } from "./document-view-decentralize";
import { DocEditor } from "./document-decentralize-title-table";

interface Props extends TagProps {
  userPermissions?: UserPermission[];
  roles?: Role[];
  onRevoke?: (data: { id: string; roles: Role[]; user: DocEditor }) => void;
}

const DocumentGrantedUsers = (props: Props) => {
  const { userPermissions = [], roles = [], onRevoke = () => {}, ...tagProps } = props;

  const handleClose = ({ id, user }: { id: string; user: DocEditor }) => {
    onRevoke({ id, roles, user });
  };

  const filteredTagsByRoles = userPermissions.filter((i) => {
    return i.roles.some((role) => roles.includes(role));
  });

  const renderedTags = (tags: UserPermission[]) => {
    return tags.map((tag) => (
      <Tag key={tag.id} closable onClose={() => handleClose({ id: tag.id!, user: tag.user! })} {...tagProps}>
        {tag.user.displayName}
      </Tag>
    ));
  };

  return <>{renderedTags(filteredTagsByRoles)}</>;
};

export default DocumentGrantedUsers;
